import { hhmm, getYYYYMMDD, checkResponse } from "src/components/js/statics1";

export default class pumiFiClass {
  constructor() {
    this.personId = undefined;
    this.key = undefined;
    this.pumiFi_personId = undefined;
  }

  static createPumiFiSaapuvaKeikka = async (keikkaData, token) => {
    const pumiFiData = pumiFiClass.getPumiFiCreateKeikkaData(keikkaData);
    pumiFiData.poisTxt =
      "betoni.online saapuva tilaus:\n" +
      pumiFiData.poisTxt +
      "\nMuokkaa, hyväksy tai hylkää tilaus osoitteessa\nhttps://betoni.online/tilaus/" +
      keikkaData.keikkaId;
    const result = await pumiFiClass.createPumiFiPalkki(pumiFiData, token);
    return result.keikkaID_v2;
  };

  static getPumiFiCreateKeikkaData = (keikkaData) => {
    let apiData = {
      id: "",
      regNo: "",
      yyyymmdd: "",
      hhmm: "",
      minutes: "",
      tehdas: "",
      haluttuPuomi: "",
      osoite: "",
      asiakas: "",
      m3: "",
      laatu: "",
      linja: "",
      contact: "",
      memo: "",
      poisTxt: "",
    };
    apiData.id = keikkaData.keikkaId;
    apiData.regNo =
      keikkaData.pumppu.vehicle.vehicleRegNo != null
        ? keikkaData.pumppu.vehicle.vehicleRegNo
        : "jemma";
    apiData.yyyymmdd = getYYYYMMDD(keikkaData.pumppu.pumppuAika);
    apiData.hhmm = hhmm(keikkaData.pumppu.pumppuAika);
    apiData.minutes = keikkaData.pumppu.pumppuKesto != null ? keikkaData.pumppu.pumppuKesto : 120;
    apiData.tehdas = keikkaData.betoniToimittaja.asiakasNimi.split(" ")[0];
    apiData.haluttuPuomi = (
      keikkaData.pumppu.isPumppu ? "P" : "B" + keikkaData.pumppu.pumppuPuomi
    ).replace("B0", "B00");
    apiData.osoite = keikkaData.tyomaa.tyomaaOsoiteString;
    apiData.asiakas = keikkaData.asiakas.asiakasNimi;
    apiData.m3 = keikkaData.betoniM3Tot + "m3";
    apiData.laatu = keikkaData.betoni[0].betoniString;
    if (keikkaData.betoni.length > 0) {
      let betoni = apiData.laatu;
      for (let i = 1; i < keikkaData.betoni.length; i++) {
        betoni += " + " + keikkaData.betoni[i].m3 + "m3 " + keikkaData.betoni[i].betoniString;
      }
      apiData.laatu = betoni;
    }
    apiData.linja =
      keikkaData.pumppu.pumppuLinja != null ? keikkaData.pumppu.pumppuLinja + "m" : "";
    apiData.contact = keikkaData.keikkaContactPerson.personPhone;
    apiData.memo = keikkaData.keikkaComment;
    apiData.poisTxt =
      apiData.haluttuPuomi +
      "/" +
      apiData.linja +
      " " +
      apiData.osoite +
      " " +
      apiData.asiakas +
      " " +
      apiData.m3 +
      " " +
      apiData.laatu +
      " " +
      (apiData.memo || "") +
      " " +
      (apiData.puhelin || "");

    apiData.poisTxt = apiData.poisTxt.trim();
    return apiData;
  };

  static getPumiFiKeikkaDelimString = (keikkaData) => {
    if (keikkaData == null) return "";
    // return |tehdas|puomi|osoite|asiakas|m3|laatu|linja|memo|puhelin|
    const tehdas = keikkaData.betoniToimittaja
      ? keikkaData.betoniToimittaja.asiakasNimi.split(" ")[0]
      : "XXX";
    const puomi = (keikkaData.pumppu.isPumppu ? "P" : "B" + keikkaData.pumppu.pumppuPuomi).replace(
      "B0",
      "B00"
    );
    const linja = keikkaData.pumppu.pumppuLinja != null ? keikkaData.pumppu.pumppuLinja + "m" : "";
    const osoite = keikkaData.tyomaa.tyomaaOsoiteString;
    const asiakas = keikkaData.asiakas.asiakasNimi;
    const m3 = keikkaData.betoniM3Tot + "m3";
    let betoni = keikkaData.betoni[0].betoniString;
    if (keikkaData.betoni.length > 0) {
      for (let i = 1; i < keikkaData.betoni.length; i++) {
        betoni += " + " + keikkaData.betoni[i].m3 + " " + keikkaData.betoni[i].betoniString;
      }
    }
    const memo = keikkaData.keikkaComment;
    const puhelin = keikkaData.keikkaContactPerson.personPhone;
    return (
      "|" +
      tehdas.replaceAll("|", " ").trim() +
      "|" +
      puomi.replaceAll("|", " ").trim() +
      "|" +
      osoite.replaceAll("|", " ").trim() +
      "|" +
      asiakas.replaceAll("|", " ").trim() +
      "|" +
      m3.replaceAll("|", " ").trim() +
      "|" +
      betoni.replaceAll("|", " ").trim() +
      "|" +
      linja.replaceAll("|", " ").trim() +
      "|" +
      memo.replaceAll("|", " ").trim() +
      "|" +
      puhelin.replaceAll("|", " ").trim() +
      "|"
    );
  };

  static getPumiFiAttachments = async (keikkaId_v2, token) => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/keikka/getAttachments/" + keikkaId_v2,
        requestOptions
      );
      const cResponse = await checkResponse(response, "pumiFiClass:getPumiFiAttachments");
      if (!cResponse.success) return false;
      const data = cResponse.data;
      return data;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  // get pumiFiData from getPumiFiCreateKeikkaData(keikkaData), edit and run createPumiFiPalkki to create palkki in pumi.fi
  static createPumiFiPalkki = async (pumiFiData, token) => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ pumiFiData }),
      };
      const response = await fetch(
        import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/keikka/createSaapuvaKeikka",
        requestOptions
      );
      const cResponse = await checkResponse(response, "pumiFiClass:createPumiFiPalkki");
      if (!cResponse.success) return false;
      const data = cResponse.data;
      return data;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  static getPumiFiPvmKeikkas = async (pvm, token) => {
    const url1 = import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/keikka/list/" + pvm;
    const response = await fetch(url1, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    const cResponse = await checkResponse(response, "pumiFiClass:getPumiFiPvmKeikkas");
    return cResponse;
  };

  static sync = async (keikkaId_v2, token, quickSync = false, forceUpdate = false) => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          keikkaID_v2: keikkaId_v2,
          quickSync: quickSync,
          forceUpdate: forceUpdate,
        }),
      };
      const response = await fetch(
        import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/keikka/sync",
        requestOptions
      );
      const cResponse = await checkResponse(response, "pumiFiClass:sync");
      return cResponse;
    } catch (err) {
      console.log(err);
      return false;
    }
  };
  // Fetch and create betoni.online keikka
  static fetchSetUpdatePumiFiKeikka = async (
    keikkaId_v2,
    token,
    socket,
    quickSync = false,
    forceUpdate = false
  ) => {
    const url1 =
      import.meta.env.VITE_SERVER_URL +
      "/api/pumi.fi/keikka/getSetUpdate/" +
      keikkaId_v2 +
      "/" +
      (quickSync ? "true" : "false") +
      "/" +
      (forceUpdate ? "true" : "false");
    const response = await fetch(url1, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "pumiFiClass:fetchSetUpdatePumiFiKeikka");
    if (!cResponse.success) return false;
    return cResponse.data;
  };

  static lomaSync = async (token) => {
    // post to /api/pumi.fi/syncPersonPvm
    const url1 = import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/syncPersonPvm";
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify(data),
    };
    const response = await fetch(url1, requestOptions);
    const cResponse = await checkResponse(response, "pumiFiClass:lomaSync");
    return cResponse;
  };

  static getPumiFiPersonHash = async (personId, token) => {
    const url1 = import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/getHash/" + personId;
    const response = await fetch(url1, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        console.error("There has been a problem with your fetch operation:pumiFI", error);
        return "Error fetching /api/pumi.fi/getHash/";
      });
    return response;
  };

  static async createPalkki_notWorking(
    token,
    regNo,
    startTime,
    endTime,
    palkkiTxt,
    keikkaId,
    keikkaId_v2
  ) {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        regNo: regNo,
        startTime: startTime,
        endTime: endTime,
        palkkiTxt: palkkiTxt,
        keikkaId: keikkaId,
        keikkaId_v2: keikkaId_v2,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/keikka/create",
      requestOptions
    );
    const cResponse = await checkResponse(response, "pumiFiClass:createPalkki");
    return cResponse.data;
  }

  static getAvailTimes = async (yyyymmdd, token) => {
    const url1 = import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/kapasiteetti/get/" + yyyymmdd;
    const response = await fetch(url1, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "pumiFiClass:getAvailTimes");
    return cResponse.data;
  };

  static fullSync = async (quickSync = true, token) => {
    const url1 = import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/fullSync/" + quickSync;
    const response = await fetch(url1, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.ok;
  };
  static quickSync = async (yyyymmdd, token, days = 5) => {
    if (days == 0) days = 5;
    const url1 =
      import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/quickSync/" + yyyymmdd + "/" + days;
    const response = await fetch(url1, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "pumiFiClass:quickSync");
    return cResponse.data;
  };
}

export async function pumiFi_attachment_upload(file, fileName, attachmentId, origFileName, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/pumi.fi/attachments/upload";
  const formData = new FormData();
  formData.append("data", file);
  formData.append("fileName", fileName);
  formData.append("attachmentId", attachmentId);
  formData.append("origFileName", origFileName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
    },
    body: formData,
  };

  try {
    return await fetch(url, requestOptions);
  } catch (error) {
    console.log(error);
    return false;
  }
}

// uid is uid of table KUTIL_attachments
export async function pumiFi_attachment_moveToSorted(uid, keikkaId_v2, token) {
  const url =
    import.meta.env.VITE_SERVER_URL +
    "/api/pumi.fi/attachments/moveToSorted/" +
    uid +
    "/" +
    keikkaId_v2;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  try {
    return await fetch(url, requestOptions);
  } catch (error) {
    console.log(error);
    return false;
  }
}
